import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@mlm/ui';
import { useMySlots } from '../lib/hooks/use-my-slots';
import { useBrand } from '../storefront/lib/hooks';
import { KitPickerDialog } from './kit-picker-dialog';

/**
 * Phase 13: gates post-slot pages (genealogy, leads, cash-out, etc). If the
 * caller has no active slot, render an activation CTA instead of the page.
 * Loading state defers rendering so we don't flash the gate during boot.
 */
export function RequireActiveSlot() {
  const brand = useBrand();
  const { hasAnyActiveSlot, isLoading } = useMySlots();
  const [pickKit, setPickKit] = useState(false);
  if (isLoading) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }
  if (!hasAnyActiveSlot) {
    return (
      <Card className="max-w-lg mx-auto mt-12">
        <CardHeader>
          <CardTitle>Activate your first slot</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            This page unlocks once you've activated a slot. Buy a {brand.kitLabel}, then redeem the
            Code+PIN in your Vault to claim a slot under your sponsor.
          </p>
          <div className="flex gap-2">
            {/* Opens the kit picker rather than linking to /storefront: that is
                the WHOLE catalog, with no kit filter, so it left a slotless
                member to work out for themselves which products activate them. */}
            <Button size="sm" onClick={() => setPickKit(true)}>
              Browse {brand.kitLabelPlural}
            </Button>
            <Button asChild size="sm" variant="outline">
              <Link to="/code-vault">
                <KeyRound className="h-4 w-4" /> Open Vault
              </Link>
            </Button>
          </div>
        </CardContent>
        <KitPickerDialog open={pickKit} onClose={() => setPickKit(false)} />
      </Card>
    );
  }
  return <Outlet />;
}
